import { Component, OnInit, Input } from '@angular/core';

@Component({
    selector: 'demooz-item',
    templateUrl: './item.component.html',
    styleUrls: ['./item.component.scss'],
})
export class DemoozItemComponent  implements OnInit {

    @Input({alias : 'fullHeight', required : false}) fullHeight: boolean = false;  

    constructor() { }

    ngOnInit() {}

}
